import * as Constants from "../constants";
import {
  ErrorPayload,
  EventHandlerPayload,
  EventPayload,
  PlayerEvent
} from "../types/common";

export type EventApiCallbacks = {
  [k in PlayerEvent]: Array<(param: unknown) => void>;
};

interface Bind {
  (name: "error", cb: (payload: EventPayload & ErrorPayload) => void): void;
  (name: PlayerEvent, cb: (payload: EventPayload) => void): void;
}

interface Dispatch {
  (
    name: PlayerEvent,
    payload?: EventPayload,
    customPayload?: EventPayload | EventHandlerPayload
  );
}

export interface PlayerEventsInterface {
  eventApiCallbacks: EventApiCallbacks;
  addListener: Bind;
  removeListener: Bind;
  removeListeners: () => void;
  dispatch: Dispatch;
}

export class PlayerEvents implements PlayerEventsInterface {
  eventApiCallbacks: EventApiCallbacks;

  constructor() {
    this.eventApiCallbacks = Constants.playerEventOptions.reduce((acc, cur) => {
      acc[cur] = [];
      return acc;
    }, {} as EventApiCallbacks);
  }

  removeListeners = (): void => {
    Object.keys(this.eventApiCallbacks).forEach(key => {
      this.eventApiCallbacks[key] = [];
    });
  };

  addListener: Bind = (name, cb) => {
    this.eventApiCallbacks[name].push(cb);
  };

  removeListener: Bind = (name, cb) => {
    this.eventApiCallbacks[name] = this.eventApiCallbacks[name].filter(
      handler => handler !== cb
    );
  };

  dispatch: Dispatch = (name, payload, customPayload) => {
    const callbacks = this.eventApiCallbacks[name];
    if (callbacks) {
      callbacks.forEach(callback => {
        try {
          callback({
            ...payload,
            ...customPayload
          });
        } catch (e) {
          console.error(e);
        }
      });
    }
  };
}
